<template>
  <div class="g-wrapper g-vertical-block">
    <div class="g-main-wrapper g-vertical-block main-content">
      <div class="material-setting">
        <div class="filter-form">
          <ElButton type="primary" @click="showMaterRulesAddModal">新建规则</ElButton>
        </div>

        <Viewport v-model="tableHeight">
          <el-table class="common-el-table-styles" ref="table" border stripe :data="tableList" :height="tableHeight">
            <el-table-column prop="ruleId" label="规则ID" width="80"> </el-table-column>
            <el-table-column prop="gameGroupName" label="游戏组" width="220"> </el-table-column>
            <el-table-column prop="mediaName" label="媒体" width="180"> </el-table-column>
            <el-table-column prop="ruleText" label="规则"> </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="{ row }">
                <el-button type="text" @click="editMaterialControlRules(row)">修改</el-button>
                <el-button type="text" @click="removeMaterialControlRules(row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pager"
            background
            layout="sizes, prev, pager, next, total"
            :page-size.sync="pager.pageSize"
            :current-page.sync="pager.pageIndex"
            :total="pager.total"
            @current-change="getListData"
          >
          </el-pagination>
        </Viewport>
      </div>

      <el-dialog title="新建规则" :visible.sync="addRulesDialogVisible" width="510px">
        <el-form label-width="80px" ref="addFormRef" :model="addForm" :rules="addFormRules">
          <el-form-item label="游戏组" prop="gameGroupId">
            <el-select v-model="addForm.gameGroupId" filterable style="width: 220px">
              <el-option v-for="item in gameGroups" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="媒体" prop="mediaId">
            <el-select v-model="addForm.mediaId" filterable style="width: 220px">
              <el-option v-for="item in mediaList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规则" prop="ruleInfo">
            <p style="font-size: 12px">消耗和ROI是统计的近15日素材数据</p>
            <div class="rule-row" v-for="(rule, index) in addForm.ruleInfo" :key="index">
              <el-select class="rule-selector" v-model="rule.name" @change="onRuleChange($event, index)">
                <el-option
                  v-for="item in RULE_NAMES"
                  :key="item.id"
                  :disabled="selectedRuleIds.includes(item.id)"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>

              <el-input class="rule-condition" :value="rule.condition"></el-input>
              <el-input class="rule-input" v-model="rule.value"> </el-input>

              <em>{{ rule.name && RULE_NAMES.find((item) => item.id === rule.name).unit }}</em>

              <em v-if="addForm.ruleInfo.length > 1" class="el-icon-error" style="cursor: pointer" @click="removeRule(index)"></em>
            </div>

            <el-button v-if="addForm.ruleInfo.length < 5" type="text" @click="addForm.ruleInfo.push(getRuleRow())">+新增规则</el-button>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onAddDialogCancel">取 消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="onAddDialogConfirm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { MessageBox } from 'element-ui'
import { getPtomGroupGames } from '@/api/material.model'
import {
  getMaterLimitRuleList,
  addMaterLimitRules,
  getMaterLimitRuleDetail,
  editMaterLimitRules,
  delMaterLimitRules
} from '@/api/report.model.js'
import { MEDIAS, GAME_GROUPS, initPageData } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([MEDIAS, GAME_GROUPS])
const gameGroups = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)
const mediaList = computed(PAGE_REQUIRED_OPTS.MEDIAS)

const addFormRef = ref(null)
const RULE_NAMES = [
  {
    id: 'planCount',
    name: '在跑计划数',
    condition: '>=',
    unit: '条'
  },
  {
    id: 'amount',
    name: '实际消耗',
    condition: '>=',
    unit: '元'
  },
  {
    id: 'roi_1',
    name: '1日ROI',
    condition: '<=',
    unit: '%'
  },
  {
    id: 'roi_3',
    name: '3日ROI',
    condition: '<=',
    unit: '%'
  },
  {
    id: 'roi_7',
    name: '7日ROI',
    condition: '<=',
    unit: '%'
  }
]
const twoDigit = /^[0-9]+([.]{1}[0-9]{1,2})?$/
const validateRules = (r, value, callback) => {
  let msg = ''
  for (let i = 0; i < value.length; i++) {
    const rule = value[i]

    if (!rule.name) {
      msg = `行${i + 1}：请选择规则`
      break
    }
    if (!rule.value) {
      msg = `行${i + 1}：请输入值`
      break
    }
    if (rule.name === 'planCount') {
      // 只能为正整数
      if (!/^[1-9]\d*$/.test(rule.value)) {
        msg = `行${i + 1}：值须为正整数`
      }
    } else {
      if (!twoDigit.test(rule.value)) {
        msg = `行${i + 1}：值须大于0，最多保留两位小数`
      }
    }
  }

  msg ? callback(new Error(msg)) : callback()
}

const addFormRules = {
  gameGroupId: [
    {
      required: true,
      message: '请选择游戏组',
      trigger: 'change'
    }
  ],
  mediaId: [
    {
      required: true,
      message: '请选择媒体',
      trigger: 'change'
    }
  ],
  ruleInfo: [{ required: true }, { validator: validateRules }]
}
const transferRuleToText = (rules) => {
  try {
    rules = JSON.parse(rules)
    rules = convertRoiRuleValue(rules, false)
    return rules
      .map((item) => {
        const rule = RULE_NAMES.find((r) => r.id === item.name)
        const name = rule?.name || ''
        return name ? `${name}${rule.condition}${item.value}${rule.unit}` : ''
      })
      .join('、')
  } catch (e) {
    console.log('transferRuleToText error output: ', e)
  }
}

const getRuleRow = () => {
  return {
    name: '',
    condition: '',
    value: ''
  }
}
const addRulesDialogVisible = ref(false)
const submitLoading = ref(false)
const addForm = ref({
  gameGroupId: '',
  mediaId: '',
  ruleInfo: [getRuleRow()]
})
const pager = ref({
  pageIndex: 1,
  pageSize: 30,
  total: 0
})
const tableList = ref([])
const tableHeight = ref(330)
// 已选中规则，用于过滤已存在的规则
const selectedRuleIds = computed(() => {
  return addForm.value.ruleInfo.map((item) => item.name)
})

function getListData() {
  const params = { pageId: pager.value.pageIndex, pageSize: pager.value.pageSize }
  getMaterLimitRuleList(params).then((data) => {
    const { list, page_info } = data
    tableList.value =
      list.map((item) => {
        return {
          ...item,
          ruleText: transferRuleToText(item.ruleInfo)
        }
      }) || []
    pager.value.total = page_info.total_number
  })
}

/**
 * @description: 选择规则后获取对应的条件符号
 * @param {*} e
 * @param {*} index
 * @return {*}
 */
function onRuleChange(e, index) {
  const rule = RULE_NAMES.find((item) => item.id === e)

  addForm.value.ruleInfo[index].condition = rule.condition
}
function showMaterRulesAddModal() {
  addFormRef.value?.clearValidate()

  addRulesDialogVisible.value = true
}
function onAddDialogCancel() {
  addRulesDialogVisible.value = false
  addForm.value = {
    gameGroupId: '',
    mediaId: '',
    ruleInfo: [getRuleRow()]
  }
}

function removeRule(index) {
  addForm.value.ruleInfo = addForm.value.ruleInfo.filter((item, i) => i !== index)
}
function editMaterialControlRules(row) {
  const ruleInfo = JSON.parse(row.ruleInfo)
  addForm.value = {
    ruleId: row.ruleId,
    gameGroupId: row.gameGroupId,
    mediaId: row.mediaId,
    ruleInfo: convertRoiRuleValue(ruleInfo, false)
  }

  showMaterRulesAddModal()
}
function removeMaterialControlRules(row) {
  MessageBox.confirm('是否确认删除该规则?', '提示', {
    type: 'warning'
  }).then(() => {
    delMaterLimitRules({ ruleId: row.ruleId }).then((data) => {
      getListData()
    })
  })
}
function onAddDialogConfirm() {
  addFormRef.value.validate((valid) => {
    if (valid) {
      submitLoading.value = true
      const ruleInfo = convertRoiRuleValue(addForm.value.ruleInfo, true)
      const params = { ...addForm.value, ruleInfo: JSON.stringify(ruleInfo) }
      ;(addForm.value.ruleId ? editMaterLimitRules(params) : addMaterLimitRules(params))
        .then((data) => {
          if (data) {
            getListData()
            onAddDialogCancel()
          }
          submitLoading.value = false
        })
        .catch(() => {
          submitLoading.value = false
        })
    }
  })
}

/**
 * @description: 转换百分百为小数 或 转换小数为百分比
 * @param {*} ruleInfo
 * @param {*} flag true | false
 * @return {*}
 */
function convertRoiRuleValue(ruleInfo, flag) {
  const needle = flag ? 100 : 0.01
  return ruleInfo.map((rule) => {
    if (rule.name.includes('roi')) {
      return { ...rule, value: rule.value / needle }
    }
    return rule
  })
}

getListData()
</script>
<style lang="scss" scoped>
.filter-form {
  padding: 10px 0;
  text-align: right;
}

.rule-row {
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;

  .rule-selector {
    min-width: 120px;
  }

  .rule-condition {
    width: 100px;
  }
  // .rule-input {
  //   flex-grow: 1;
  //   width: auto;
  // }
}

.pager {
  text-align: right;
  padding: 10px 0;
}
</style>
